import { httpClient } from '../util/http-client'

export const onboardingFetcher = async (url: string) => {
  const { data } = await httpClient(url, { onboardingService: true })

  return data
}
